import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AnimatedNumber from "../../common/components/AnimatedNumber";
import { SPACING } from "../../common/constants/spacing";

const GeneralStatsCard = ({ analytics, showAssetCount = false }) => {
  const { t } = useTranslation("analytics");

  return (
    <Grid size={{ md: 6, xs: 12 }}>
      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent sx={{ p: 3, height: "100%" }}>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
            {t("cards.generalStats")}
          </Typography>

          <Box
            sx={{ display: "flex", flexDirection: "column", gap: SPACING.sm }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.impressions")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.total_impressions}
                />
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.revenueFromImpressions")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.total_impression_revenue}
                  isCurrency
                />
              </Typography>
            </Box>
            {showAssetCount && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography color="text.primary">
                  {t("metrics.assets")}
                </Typography>
                <Typography color="primary.main">
                  <AnimatedNumber
                    section="statsCards"
                    value={analytics?.asset_count}
                  />
                </Typography>
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default GeneralStatsCard;
